import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect } from 'react';
import { cloneDeep } from "lodash";
import { useOutletContext, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { TextField, InputAdornment, Grid, Box, Divider, Typography, Button, } from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";

import btn_general from "assets/images/icons/btn_general.svg";
import btn_general_light from "assets/images/icons/btn_general_light.svg";
import btn_smtp from "assets/images/icons/btn_smtp.svg";
import btn_smtp_light from "assets/images/icons/btn_smtp_light.svg";
import btn_alert from "assets/images/icons/btn_alert.svg";
import btn_alert_light from "assets/images/icons/btn_alert_light.svg";

import { ReactComponent as LeaveIcon } from "assets/images/icons/icn_table_cell_Launch.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin_red.svg";
import { ReactComponent as SwitchOnIcon } from "assets/images/icons/Toggle-On.svg";
import { ReactComponent as SwitchOffIcon } from "assets/images/icons/Toggle-Off.svg";
import { ReactComponent as CheckOnIcon } from "assets/images/icons/checkbox_fiilled.svg";
import { ReactComponent as CheckOffIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as ConnectIcon } from "assets/images/icons/icn_btn_connection.svg";
import { ReactComponent as SendMailIcon } from "assets/images/icons/icn_btn_send_mail.svg";
import { ReactComponent as InfoAlertIcon } from "assets/images/icons/icn_board_alert.svg";
import { ReactComponent as InfoSuccessIcon } from "assets/images/icons/icn_success.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";
import { ReactComponent as UnverifiedIcon } from "assets/images/icons/icn_table_cell_Unverified.svg";
import { ReactComponent as AddIcon } from "assets/images/icons/icn_table_cell_Add.svg";
import { ReactComponent as AddHoverIcon } from "assets/images/icons/icn_table_cell_Add_hover.svg";
// Service
import { useUserContext } from 'contexts/UserContext';
import useDataSourceManager from "hooks/useDataSourceManager";

import ModalContainer from 'components/ModalContainer';
import ModalforCheck from '../modalCheck.js';
import ModalConfirmPw from "../modalConfirmPw";
import Notifications from "./Notifications";

import { MenuSelect } from "components/Select/menuSelect";
import AutocompleteSelect from "components/Select/AutocompleteSelect";
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";
import { SolidRectangleLightButton } from "components/buttons/SolidRectangleLightButton";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

import { getCountryList, getTimezoneList } from "utils/timezone";
import { validateDeviceAccount, validateDeviceAccountPassword } from 'utils/validate';

const checkMockup = process.env.REACT_APP_IS_MOCKUP;
const checkContext = process.env.REACT_APP_RUNNING_CONTEXT;

const StyledIconButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.transparent,
  width: "22px",
  height: "22px",
  minWidth: "16px",
  padding: "0",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.transparent,
  },
}));

const MspLevel = () => {
  const { scopeData, setScopeData, scopeReady } = useOutletContext();
  const { userState } = useUserContext();
  const navigate = useNavigate();

  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } = useDataSourceManager();

  const [nowAnchor, setNowAnchor] = useState('account');
  const handleAnchor = (section) => {
    setNowAnchor(section)
  }

  const [testConnectBtnText, setTestConnectBtnText] = useState('Test Connection');
  const [sendMailBtnText, setSendMailBtnText] = useState('Send Test Email');

  const [nowScope, setNowScope] = useState('');
  const [showEditGeneral, setShowEditGeneral] = useState(true);
  const [checkScopeName, setCheckScopeName] = useState(true);

  const [showLeaveGeneral, setShowLeaveGeneral] = useState(true);
  const [showDeleteGeneral, setShowDeleteGeneral] = useState(true);
  const [showInventory, setShowInventory] = useState(true);

  const [enableCaptcha, setEnableCaptcha] = useState(false);
  const [enableSMTP, setEnableSMTP] = useState(false);

  const [host, setHost] = useState('');
  const [port, setPort] = useState('');
  const [authName, setAuthName] = useState('');
  const [authPW, setAuthPW] = useState('');
  const [enableAuth, setEnableAuth] = useState(false);
  const [enableSslTls, setEnableSslTls] = useState(false);
  const [mail, setMail] = useState('');
  const [senderName, setSenderName] = useState('');
  const [receiverMail, setReceivertMail] = useState('');

  const [checkHost, setCheckHost] = useState(true);
  const [checkPort, setCheckPort] = useState(true);
  const [checkAuthName, setCheckAuthName] = useState(true);
  const [checkAuthPW, setCheckAuthPW] = useState(true);
  const [checkMail, setCheckMail] = useState(true);
  const [checkSenderName, setCheckSenderName] = useState(true);
  const [checkReceivertMail, setCheckReceivertMail] = useState(true);

  const [showConnectInfo, setShowConnectInfo] = useState(false);
  const [testConnectResult, setTestConnectResult] = useState({
    type: '', message: ''
  });
  const [showSendInfo, setShowSendInfo] = useState(false);
  const [sendMailResult, setSendMailResult] = useState({
    type: '', message: ''
  });

  const [informHost, setInformHost] = useState('');
  const [enableCusInform, setEnableCusInform] = useState(true);
  const [checkInformHost, setCheckInformHost] = useState(true);

  const [originPremGenral, setOriginPremGenral] = useState('');
  const [originPremSMTP, setOriginPremSMTP] = useState('');
  const [originPremInform, setOriginPremInform] = useState('');

  const [openModalConfirmPw, setOpenModalConfirmPw] = useState(false);
  const [openModalCheck, setOpenModalCheck] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [modalSaveBtn, setModalSaveBtn] = useState('');
  const [modalCancelBtn, setModalCancelBtn] = useState('');
  const [originUser, setOriginUser] = useState('');
  // for modalCheck to check from where
  const [modalFrom, setModalFrom] = useState('');

  const [readNameUuid, _setReadNameUuid] = useState(uuidv4());
  const [updateNameUuid, _setUpdateNameUuid] = useState(uuidv4());
  const [deleteNameUuid, _setDeleteNameUuid] = useState(uuidv4());
  const [leaveNameUuid, _setLeaveNameUuid] = useState(uuidv4());
  const [readSMTPUuid, _setReadSMTPUuid] = useState(uuidv4());
  const [updateSMTPUuid, _setUpdateSMTPUuid] = useState(uuidv4());
  const [testConnectUuid, _setTestConnectUuid] = useState(uuidv4());
  const [sendMailUuid, _setSendMailUuid] = useState(uuidv4());
  const [readInformUuid, _setReadInformUuid] = useState(uuidv4());
  const [updateInformUuidm, _setUpdateInformUuid] = useState(uuidv4());
  const [readInventoryUuid, _setReadInventoryUuid] = useState(uuidv4());
  const [updateInventoryUuid, _setUpdateInventoryUuid] = useState(uuidv4());

  const [nowUuid, setNowUuid] = useState('');

  const [isAddHovered, setIsAddHovered] = useState(false);
  const [showDevicePw, setShowDevicePw] = useState(false);
  const [userError, setUserError] = useState("");
  const [userPWError, setUserPWError] = useState("");

  const [readGeneralUuid, _setReadGeneralUuid] = useState(uuidv4());
  const [updateGeneralUuid, _setUpdateGeneralUuid] = useState(uuidv4());

  // 原始資料
  const [originalInfoData, setOriginalInfoData] = useState({});
  const [originalCountryDomainData, setOriginalCountryDomainData] = useState({});
  const [originalTimezoneList, setOriginalTimezoneList] = useState([]);
  const [originalTimezoneData, setOriginalTimezoneData] = useState({});
  const [originalNtpServers, setOriginalNtpServers] = useState([]);
  const [originalInventoryDeviceAccountData, setOriginalInventoryDeviceAccountData] = useState({});
  // 當前填入的資料
  const [scopeName, setScopeName] = useState('');
  const [selectCountryList, setSelectCountryList] = useState([]);
  const [selectCountry, setSelectCountry] = useState({});
  const [timezoneList, setTimezoneList] = useState([]);
  const [selectTimezoneData, setSelectTimezoneData] = useState({});
  const [ntpServers, setNtpServers] = useState([]);
  const [inventoryName, setInventoryName] = useState('');
  const [inventoryPW, setInventoryPW] = useState('');

  useEffect(() => {
    if (userState) {
      setOriginUser(userState)
    }
  }, [userState]);

  useEffect(() => {
    let nowSelectedBread = JSON.parse(
      localStorage.getItem("selectBreadcrumbs") || "{}"
    );

    if ((Object.keys(nowSelectedBread).length !== 0 && scopeReady) || checkMockup === 'true') {
      // msp enterprise or stand alone org
      setShowLeaveGeneral(true)
      setShowDeleteGeneral(false)
      setShowEditGeneral(false)
      setShowInventory(true)

      // setScopeName(nowSelectedBread.realm.name)
      if (nowSelectedBread.realm.hasManageOrg === true) {
        setShowInventory(false)
        setNowScope('MSP')
        if (nowSelectedBread.realm.roleId === 1 || nowSelectedBread.realm.roleId === 2) {
          setShowEditGeneral(true)
          if (nowSelectedBread.realm.roleId === 1) {
            setShowDeleteGeneral(true)
          }
        }
      } else {
        setNowScope('Organization')
        if (nowSelectedBread.realm.roleId === 5 || nowSelectedBread.realm.roleId === 6) {
          setShowEditGeneral(true)
          if (nowSelectedBread.realm.roleId === 5) {
            setShowDeleteGeneral(true)
          }
        }
      }

      let tmpItem = cloneDeep(nowSelectedBread.realm)
      if (checkContext === 'cloud' && checkMockup !== 'true') {
        if (nowSelectedBread.realm.hasManageOrg !== true) {
          readInventory(tmpItem)
        }
      } else if (checkContext !== 'cloud' && checkMockup !== 'true') {
        readManageOrg(tmpItem)
        // readSmtpSetting(tmpItem)
        // readInformHost(tmpItem)
        // readInventory(tmpItem)
      }
    }
  }, [scopeReady]);

  useEffect(() => {
    if (nowScope === 'MSP') {
      let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
      let tmpItem = cloneDeep(tmpSelectedBread.realm)

      sendRequest("/ents/:entId/settings/general.read", readGeneralUuid, { entId: tmpItem.id });
    }
    // standalone
    if (nowScope === 'Organization') {
      const tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

      const restfulParams = {
        orgId: tmpSelectedBread.realm.id,
      }

      sendRequest("/orgs/:orgId/settings/general.read", readGeneralUuid, restfulParams);
    }
  }, [nowScope])

  // dataMap 先分開做 未來有機會一次整合全部的 dataMap 行為
  useEffect(() => {
    const response = getData(readGeneralUuid);
    if (nowScope === 'MSP' && response && response.data) {
      setOriginalInfoData(response.data)
      setScopeName(response.data.entName)
    }
    // standalone
    if (nowScope === 'Organization' && response && response.data) {
      const { info, countryDomain, timeConfig, inventoryDeviceAccount } = response.data;

      setOriginalInfoData(info)
      setScopeName(info.orgName)

      const currentSelectCountryList = getCountryList();
      setSelectCountryList(currentSelectCountryList)

      const currentCountry = currentSelectCountryList.find((item) => item.value === countryDomain.countryIndex)
      setOriginalCountryDomainData(currentCountry)
      setSelectCountry(currentCountry);

      const timezoneList = getTimezoneList(countryDomain.countryIndex);
      setOriginalTimezoneList(timezoneList)
      setTimezoneList(timezoneList)
      const currentTimezoneData = timezoneList.find((item) => item.value === timeConfig.timezone)
      setOriginalTimezoneData(currentTimezoneData)
      setSelectTimezoneData(currentTimezoneData)

      const formattedData = [timeConfig.ntpServer1, timeConfig.ntpServer2, timeConfig.ntpServer3].filter(Boolean);
      setOriginalNtpServers(formattedData)
      setNtpServers(formattedData)

      setOriginalInventoryDeviceAccountData(inventoryDeviceAccount);
      setInventoryName(inventoryDeviceAccount.userName)
      setInventoryPW(inventoryDeviceAccount.password)
    }
  }, [dataMap])

  useEffect(() => {
    if (selectCountry && selectCountry.value) {
      const timezoneList = getTimezoneList(selectCountry.value);
      setTimezoneList(timezoneList);

      if (selectCountry.value === originalCountryDomainData.value && originalTimezoneData) {
        setSelectTimezoneData(originalTimezoneData);
      } else {
        setSelectTimezoneData(timezoneList[0]);
      }
    }
  }, [selectCountry])

  function handleAddNtpServer() {
    if (ntpServers.length < 3) {
      setNtpServers([...ntpServers, ""]);
    }
  }

  function handleDeleteNtpServer(index) {
    const updated = ntpServers.filter((_, i) => i !== index);
    setNtpServers(updated);
  }

  function handleChangeNtpServer(value, index) {
    const updated = [...ntpServers];
    updated[index] = value;
    setNtpServers(updated);
  }

  const handleCheck = (key) => {
    if (!showEditGeneral) { return; }

    let tmpCheck;
    switch (key) {
      case "auth":
        tmpCheck = cloneDeep(enableAuth)
        setEnableAuth(!tmpCheck)
        break;
      case "ssltls":
        tmpCheck = cloneDeep(enableSslTls)
        setEnableSslTls(!tmpCheck)
        break;
      case "cusInform":
        tmpCheck = cloneDeep(enableCusInform)
        setEnableCusInform(!tmpCheck)
        break;
      default:
        break;
    }
  }

  const handleSwitchCaptcha = () => {
    if (!showEditGeneral) { return; }

    let tmpSwitch = cloneDeep(enableCaptcha)
    setEnableCaptcha(!tmpSwitch)
  }
  const handleSwitchSMTP = () => {
    if (!showEditGeneral) { return; }

    let tmpSwitch = cloneDeep(enableSMTP)
    setEnableSMTP(!tmpSwitch)
  }

  const handleInput = (e, key) => {
    let tmpVal = e.target.value;
    switch (key) {
      case "host":
        setHost(tmpVal)
        break;
      case "port":
        setPort(tmpVal)
        break;
      case "mail":
        setMail(tmpVal)
        break;
      case "senderName":
        setSenderName(tmpVal)
        break;
      case "receiverMail":
        setReceivertMail(tmpVal)
        break;
      case "authName":
        setAuthName(tmpVal)
        break;
      case "authPW":
        setAuthPW(tmpVal)
        break;
      case "scopeName":
        setScopeName(tmpVal)
        break;
      case "informHost":
        setInformHost(tmpVal)
        break;
      case "inventoryName":
        setInventoryName(tmpVal)
        const userErrorResult = validateDeviceAccount(tmpVal);
        setUserError(userErrorResult.valid ? "" : userErrorResult.msg);
        break;
      case "inventoryPW":
        setInventoryPW(tmpVal)
        const pwErrorResult = validateDeviceAccountPassword(tmpVal, inventoryName);
        setUserPWError(pwErrorResult.valid ? "" : pwErrorResult.msg);
        break;
      default:
        break;
    }
  }

  const handleCancelSMTP = () => {
    if (!showEditGeneral || checkMockup === 'true') { return; }

    setEnableSMTP(originPremSMTP.active)
    setHost(originPremSMTP.server.host)
    setPort(originPremSMTP.server.port)
    setEnableAuth(originPremSMTP.server.authEnabled)
    setAuthName(originPremSMTP.server.username)
    setAuthPW(originPremSMTP.server.password)
    setEnableSslTls(originPremSMTP.server.sslTlsEnabled)
    setMail(originPremSMTP.sender.email)
    setSenderName(originPremSMTP.sender.from)
    setReceivertMail(originPremSMTP.sender.receiverEmail)
  }

  const handleSaveSMTP = () => {
    if (!showEditGeneral || checkMockup === 'true') { return; }

    if (enableSMTP) {
      //檢查欄位
      let pass = true;
      if (!isNumeric(port)) {
        pass = false;
        setCheckPort(false)
      } else {
        setCheckPort(true)
      }

      if (isEmpty(host)) {
        pass = false;
        setCheckHost(false)
      } else {
        setCheckHost(true)
      }

      if (isEmpty(mail)) {
        pass = false;
        setCheckMail(false)
      } else {
        setCheckMail(true)
      }

      if (isEmpty(senderName)) {
        pass = false;
        setCheckSenderName(false)
      } else {
        setCheckSenderName(true)
      }

      if (isEmpty(receiverMail)) {
        pass = false;
        setCheckReceivertMail(false)
      } else {
        setCheckReceivertMail(true)
      }

      // check password > *** 是否是同username沿用舊密碼, 有改username 但維持*** or 自己輸入*** =error
      if (!enableAuth) {
        // 關閉 = 維持舊的
        setAuthName(originPremSMTP.server.username)
        setAuthPW(originPremSMTP.server.password)
      } else { // 打開
        if (originPremSMTP.server.authEnabled === enableAuth
          && originPremSMTP.server.username === authName) {
          // 維持打開 && username維持
          setCheckAuthName(true)
          if (authPW != '***') {
            if (isEmpty(authPW)) {
              pass = false;
              setCheckAuthPW(false)
            } else {
              const regex = /^\*+$/;
              let testResult = regex.test(authPW)
              if (testResult) { // check ***
                pass = false;
                setCheckAuthPW(false)
              } else {
                setCheckAuthPW(true) //不為空 & 不為***
              }
            }
          }
        } else { // 新開 or 維持打開 but username改過
          if (isEmpty(authName)) {
            pass = false;
            setCheckAuthName(false)
          } else {
            setCheckAuthName(true)
          }

          if (isEmpty(authPW)) {
            pass = false;
            setCheckAuthPW(false)
          } else {
            const regex = /^\*+$/;
            let testResult = regex.test(authPW)
            if (testResult) { // check ***
              pass = false;
              setCheckAuthPW(false)
            } else {
              setCheckAuthPW(true) //不為空 & 不為***
            }
          }
        }
      }
      if (!pass) {
        return;
      }
    }
    let tmpItem = cloneDeep(originPremSMTP)
    tmpItem.active = enableSMTP
    if (enableSMTP) {
      tmpItem.server.host = host
      tmpItem.server.port = Number(port)
      tmpItem.server.authEnabled = enableAuth
      tmpItem.server.username = authName
      tmpItem.server.password = authPW
      tmpItem.server.sslTlsEnabled = enableSslTls
      tmpItem.sender.email = mail
      tmpItem.sender.from = senderName
      tmpItem.sender.receiverEmail = receiverMail
    }

    // enableSMTP = flase > 預設originPremSMTP資料但更新active
    updateSmtpSetting(tmpItem)
  }

  const handleCancelGeneral = () => {
    // if(!showEditGeneral || checkMockup === 'true'){ return; }

    // let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    // setScopeName(tmpSelectedBread.realm.name)
    // if(checkContext === 'premises'){
    //   setEnableCaptcha(originPremGenral.captcha)
    // }

    if (nowScope === 'MSP') {
      setScopeName(originalInfoData.entName);
    }
    // standalone
    if (nowScope === 'Organization') {
      setScopeName(originalInfoData.orgName);
      setSelectCountry(originalCountryDomainData);
      setTimezoneList(originalTimezoneList)
      setSelectTimezoneData(originalTimezoneData);
      setNtpServers(originalNtpServers);
      setInventoryName(originalInventoryDeviceAccountData.userName)
      setInventoryPW(originalInventoryDeviceAccountData.password)
      setUserError('')
      setUserPWError('')
    }
  }

  const handleSaveGeneral = () => {
    // if(!showEditGeneral || checkMockup === 'true'){ return; }

    // if(isEmpty(scopeName)){
    //   setCheckScopeName(false)
    //   return;
    // }else{
    //   setCheckScopeName(true)
    // }

    // let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    // let tmpItem = cloneDeep(tmpSelectedBread.realm)
    // tmpItem.name = scopeName;
    // updateManageOrg(tmpItem)

    const tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    if (nowScope === 'MSP') {
      const restfulParams = {
        entId: tmpSelectedBread.realm.id,
      }

      const requestParams = {
        data: {
          name: scopeName
        }
      }

      sendRequest("/ents/:entId/settings/general.update", updateGeneralUuid, restfulParams, requestParams);
    }
    // standalone
    if (nowScope === 'Organization') {
      const restfulParams = {
        orgId: tmpSelectedBread.realm.id,
      }

      const requestParams = {
        data: {
          info: {
            "orgId": originalInfoData.orgId,
            "orgName": scopeName,
          },
          countryDomain: {
            "countryIndex": selectCountry.value
          },
          timeConfig: {
            "timezone": selectTimezoneData.value,
            "ntpServer1": ntpServers[0] || "",
            "ntpServer2": ntpServers[1] || null,
            "ntpServer3": ntpServers[2] || null,
          },
          inventoryDeviceAccount: {
            "userName": inventoryName,
            "password": inventoryPW
          }
        }
      }

      sendRequest("/orgs/:orgId/settings/general.update", updateGeneralUuid, restfulParams, requestParams);
    }
  }

  // dataMap 先分開做 未來有機會一次整合全部的 dataMap 行為
  useEffect(() => {
    const response = getData(updateGeneralUuid);
    if (nowScope === 'MSP' && response) {
      setOriginalInfoData((pre) => ({ ...pre, entName: scopeName }))

      let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
      tmpSelectedBread.realm.name = scopeName;
      localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));
    }
    // standalone
    if (nowScope === 'Organization' && response) {
      setOriginalInfoData((pre) => ({ ...pre, orgName: scopeName }))

      let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
      tmpSelectedBread.realm.name = scopeName;
      localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));

      setOriginalCountryDomainData(selectCountry)
      setOriginalTimezoneList(timezoneList)
      setOriginalTimezoneData(selectTimezoneData)
      setOriginalNtpServers(ntpServers)
      setOriginalInventoryDeviceAccountData({ userName: inventoryName, password: inventoryPW })
    }
  }, [dataMap])

  const handleDeleteSetting = () => {
    setModalTitle('Delete ' + scopeName)
    setModalContent('Enter your password to delete all settings.')
    setModalSaveBtn('Delete')
    setModalCancelBtn('Cancel')
    setOpenModalConfirmPw(true)
  }
  const handleLeaveSetting = () => {
    setModalTitle('Leave ' + scopeName)
    setModalContent('Are you sure you want to leave?')
    setModalSaveBtn('Leave')
    setModalCancelBtn('Cancel')
    setModalFrom('leave')
    setOpenModalCheck(true)
  }

  const handleCancelInformHost = () => {
    if (!showEditGeneral || checkMockup === 'true') { return; }

    setEnableCusInform(originPremInform.active)
    if (originPremInform.active) {
      setInformHost(originPremInform.informUrl)
    } else {
      setInformHost('')
    }
  }

  const handleSaveInformHost = () => {
    setNowUuid(updateInformUuidm)

    if (enableCusInform) {
      if (informHost === '') {
        setCheckInformHost(false);
        return;
      }
    }

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpItem = cloneDeep(tmpSelectedBread.realm)

    let tmpParam = {
      active: enableCusInform,
      informUrl: informHost
    }

    let tmpResource = '/orgs/:orgId/settings/informHost.update';
    let tmpResourceAPIval = { orgId: tmpItem.id }

    sendRequest(tmpResource, updateInformUuidm, tmpResourceAPIval, { param: tmpParam });
  }

  const handleTestConnect = () => {
    if (!showEditGeneral || checkMockup === 'true') { return; }
    setNowUuid(testConnectUuid)

    setShowConnectInfo(false)
    //check port
    if (!isNumeric(port)) {
      setCheckPort(false)
      return;
    } else {
      setCheckPort(true)
      setTestConnectBtnText('Testting...')
    }
    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpItem = cloneDeep(tmpSelectedBread.realm)
    let tmpParam = {
      server: {
        host: host,
        port: Number(port),
        authEnabled: enableAuth,
        username: authName,
        password: authPW,
        sslTlsEnabled: enableSslTls,
      }
    }

    let tmpResource = '/orgs/:orgId/settings/emailProviders/default/testConnection.update';
    let tmpResourceAPIval = { orgId: tmpItem.id }

    sendRequest(tmpResource, testConnectUuid, tmpResourceAPIval, { param: tmpParam });
  }

  const handleSendMail = () => {
    if (!showEditGeneral || checkMockup === 'true') { return; }
    setNowUuid(sendMailUuid)

    setShowSendInfo(false)
    //check port
    if (!isNumeric(port)) {
      setCheckPort(false)
      return;
    } else {
      setCheckPort(true)
      setSendMailBtnText('Send...')
    }

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpItem = cloneDeep(tmpSelectedBread.realm)
    let tmpParam = {
      server: {
        host: host,
        port: Number(port),
        authEnabled: enableAuth,
        username: authName,
        password: authPW,
        sslTlsEnabled: enableSslTls,
      },
      sender: {
        email: mail,
        from: senderName,
        receiverEmail: receiverMail
      }
    }

    let tmpResource = '/orgs/:orgId/settings/emailProviders/default/sendTestEmail.update';
    let tmpResourceAPIval = { orgId: tmpItem.id }

    sendRequest(tmpResource, sendMailUuid, tmpResourceAPIval, { param: tmpParam });
  }

  const handleEnableCusInform = () => {
    if (!showEditGeneral) {
      return;
    }

    let tmpEnable = cloneDeep(enableCusInform)
    if (tmpEnable) {
      setInformHost('')
      handleCheck('cusInform')
    } else {
      let contentTxt = 'Content: Make sure the hostname or IP you provide is accessible by all devices you plan to manage. </br>If unreachable, devices may fail to connect or require manual recovery.'
      setModalTitle('Custom Inform Host')
      setModalContent(contentTxt)
      setModalSaveBtn('Confirm')
      setModalCancelBtn('Cancel')
      setModalFrom('cusInform')
      setOpenModalCheck(true)
    }
  }

  const readInventory = async (item) => {
    setNowUuid(readInventoryUuid)
    let tmpResource = '/orgs/:orgId/settings/inventoryDeviceAccount.read';
    let tmpResourceAPIval = { orgId: item.id }

    sendRequest(tmpResource, readInventoryUuid, tmpResourceAPIval);
  }

  const readInformHost = async (item) => {
    setNowUuid(readInformUuid)

    let tmpResource = '/orgs/:orgId/settings/informHost.read';
    let tmpResourceAPIval = { orgId: item.id }

    sendRequest(tmpResource, readInformUuid, tmpResourceAPIval);
  }

  const readSmtpSetting = async (item) => {
    setNowUuid(readSMTPUuid)

    let tmpResource = '/orgs/:orgId/settings/emailProviders/default.read';
    let tmpResourceAPIval = { orgId: item.id }

    sendRequest(tmpResource, readSMTPUuid, tmpResourceAPIval);
  }

  const readManageOrg = async (item) => {
    setNowUuid(readNameUuid)

    let tmpResource = '/orgs/:orgId.read';
    let tmpResourceAPIval = { orgId: item.id }

    sendRequest(tmpResource, readNameUuid, tmpResourceAPIval);
  }

  const updateInventory = async (item) => {
    setNowUuid(updateInventoryUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpResource = '/orgs/:orgId/settings/inventoryDeviceAccount.update';
    let tmpParam = { username: inventoryName, password: inventoryPW };
    let tmpResourceAPIval = {
      orgId: tmpSelectedBread.realm.id
    }

    sendRequest(tmpResource, updateInventoryUuid, tmpResourceAPIval, { param: tmpParam });
  }

  const updateSmtpSetting = async (params) => {
    setNowUuid(updateSMTPUuid)

    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
    let tmpItem = cloneDeep(tmpSelectedBread.realm)

    let tmpResource = '/orgs/:orgId/settings/emailProviders/default.update';
    let tmpResourceAPIval = { orgId: tmpItem.id }

    sendRequest(tmpResource, updateSMTPUuid, tmpResourceAPIval, { param: params });
  };

  const updateManageOrg = async (item) => {
    setNowUuid(updateNameUuid)

    let tmpResource = '';
    let tmpParam = '';
    let tmpCaptcha = 'inactive'
    let tmpResourceAPIval = {}

    if (checkContext === 'premises' && enableCaptcha === true) {
      tmpCaptcha = 'active'
    }

    if (item.hasManageOrg === true) {
      tmpResourceAPIval = { entId: item.id }
      tmpResource = '/ents/:entId.update'
      // tmpResource = '/ents/'+item.id;
      tmpParam = {
        name: item.name,
        captcha: tmpCaptcha
      }
    } else {
      tmpResourceAPIval = { orgId: item.id }
      tmpResource = '/orgs/:orgId.update'
      // tmpResource = '/orgs/'+item.id;
      tmpParam = {
        orgName: item.name,
        captcha: tmpCaptcha
      }
    }

    sendRequest(tmpResource, updateNameUuid, tmpResourceAPIval, { param: tmpParam });
  };

  const delManageOrg = async (item) => {
    setNowUuid(deleteNameUuid)

    let tmpResource = '';
    let tmpResourceAPIval = {}
    if (item.hasManageOrg === true) {
      tmpResourceAPIval = { entId: item.id, }
      tmpResource = '/ents/:entId.delete'
      // tmpResource = '/ents/'+item.id;
    } else {
      tmpResourceAPIval = { orgId: item.id, }
      tmpResource = '/orgs/:orgId.delete'
      // tmpResource = '/orgs/'+item.id;
    }

    sendRequest(tmpResource, deleteNameUuid, tmpResourceAPIval);
  };

  const leaveManageOrg = async (item) => {
    setNowUuid(leaveNameUuid)

    let tmpResource = '';
    let tmpResourceAPIval = {}
    if (item.hasManageOrg === true) {
      tmpResourceAPIval = { entId: item.id, }
      tmpResource = '/ents/:entId/leave.update'
      // tmpResource = '/ents/'+item.id+'/leave';
    } else {
      tmpResourceAPIval = { orgId: item.id, }
      tmpResource = '/orgs/:orgId/leave.update'
      // tmpResource = '/orgs/'+item.id+'/leave';;
    }

    sendRequest(tmpResource, leaveNameUuid, tmpResourceAPIval);
  };

  useEffect(() => {
    if (nowUuid !== '') {
      // console.log(dataMap[nowUuid])
      let nowSelectedBread = JSON.parse(
        localStorage.getItem("selectBreadcrumbs") || "{}"
      );
      let tmpItem = cloneDeep(nowSelectedBread.realm)
      let tmpTestResult = { type: '', message: '' }

      switch (nowUuid) {
        case updateNameUuid:
          if (dataMap[updateNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[updateNameUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateNameUuid] !== undefined) {
            let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
            tmpSelectedBread.realm.name = scopeName;
            localStorage.setItem('selectBreadcrumbs', JSON.stringify(tmpSelectedBread));

            const targetScope = cloneDeep(scopeData.realm);
            const updateScope = targetScope.map(item =>
              item.id === tmpSelectedBread.realm.id ? { ...item, name: scopeName } : item
            );
            setScopeData(prev => ({
              ...prev,
              realm: updateScope
            }))

            setModalTitle('Success')
            setModalContent('Your setting has been updated successfully.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('refresh')
            setOpenModalCheck(true)
          }
          setNowUuid('')

          if (tmpItem.hasManageOrg !== true) {
            updateInventory()
          }
          break;
        case deleteNameUuid:
          if (dataMap[deleteNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[nowUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[deleteNameUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('It will redirect to the realm home page later.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('navigate')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case leaveNameUuid:
          if (dataMap[leaveNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[nowUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[leaveNameUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('It will redirect to the realm home page later.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('navigate')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case readNameUuid:
          if (dataMap[readNameUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[readNameUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[readNameUuid]?.data !== undefined) {
            let tmpData = dataMap[readNameUuid].data;
            setOriginPremGenral(tmpData)
            setEnableCaptcha(tmpData.captcha)
          }
          setNowUuid('')

          readSmtpSetting(tmpItem)
          break;
        case readSMTPUuid:
          if (dataMap[readSMTPUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[readSMTPUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[readSMTPUuid]?.data !== undefined) {
            let tmpData = dataMap[readSMTPUuid].data;
            setOriginPremSMTP(tmpData)
            setEnableSMTP(tmpData.active)
            setHost(tmpData.server.host)
            setPort(tmpData.server.port)
            setEnableAuth(tmpData.server.authEnabled)
            setAuthName(tmpData.server.username)
            setAuthPW(tmpData.server.password)
            setEnableSslTls(tmpData.server.sslTlsEnabled)
            setMail(tmpData.sender.email)
            setSenderName(tmpData.sender.from)
            setReceivertMail(tmpData.sender.receiverEmail)
          }
          setNowUuid('')

          readInformHost(tmpItem)
          break;
        case readInformUuid:
          if (dataMap[readInformUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[readInformUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[readInformUuid]?.data !== undefined) {
            let tmpData = dataMap[readInformUuid].data;
            setOriginPremInform(tmpData)
            setEnableCusInform(tmpData.active)
            if (tmpData.active === true) {
              setInformHost(tmpData.informUrl)
            } else {
              setInformHost('')
            }
          }
          setNowUuid('')

          readInventory(tmpItem)
          break;
        case updateSMTPUuid:
          if (dataMap[updateSMTPUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[nowUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateSMTPUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('Your setting has been updated successfully.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('OK')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case updateInformUuidm:
          if (dataMap[updateInformUuidm]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[nowUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateInformUuidm] !== undefined) {
            setModalTitle('Success')
            setModalContent('Your setting has been updated successfully.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('OK')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        case testConnectUuid:
          setShowConnectInfo(true)
          setTestConnectBtnText('Test Connection')
          if (dataMap[testConnectUuid]?.code !== undefined) {
            tmpTestResult.type = 'error'
            tmpTestResult.message = (dataMap[nowUuid].message)
          } else if (dataMap[testConnectUuid] !== undefined) {
            tmpTestResult.type = 'ok'
            tmpTestResult.message = 'Test success'
          }
          setTestConnectResult(tmpTestResult)
          setNowUuid('')
          break;
        case sendMailUuid:
          setShowSendInfo(true)
          setSendMailBtnText('Send Test Email')
          if (dataMap[sendMailUuid]?.code !== undefined) {
            tmpTestResult.type = 'error'
            tmpTestResult.message = (dataMap[nowUuid].message)
          } else if (dataMap[sendMailUuid] !== undefined) {
            tmpTestResult.type = 'ok'
            tmpTestResult.message = 'Test success'
          }
          setSendMailResult(tmpTestResult)
          setNowUuid('')
          break;
        case readInventoryUuid:
          if (dataMap[readInventoryUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[readInventoryUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[readInventoryUuid]?.data !== undefined) {
            let tmpData = dataMap[readInventoryUuid].data;
            setInventoryName(tmpData.username)
            setInventoryPW(tmpData.password)
          }
          setNowUuid('')
          break;
        case updateInventoryUuid:
          if (dataMap[updateInventoryUuid]?.code !== undefined) {
            setModalTitle('Action denied')
            setModalContent(dataMap[updateInventoryUuid].message)
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('error')
            setOpenModalCheck(true)
          } else if (dataMap[updateInventoryUuid] !== undefined) {
            setModalTitle('Success')
            setModalContent('Your setting has been updated successfully.')
            setModalCancelBtn('')
            setModalSaveBtn('OK')
            setModalFrom('refresh')
            setOpenModalCheck(true)
          }
          setNowUuid('')
          break;
        default:
          break;
      }
    }
  }, [dataMap]);

  const handleShowDevicePw = (e) => {
    let tmpVal = showDevicePw;
    setShowDevicePw(!tmpVal)
  }

  const handleCheckModalAction = (value) => {
    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    if (value === 'ok') {
      if (modalFrom === 'leave') {
        let tmpItem = cloneDeep(tmpSelectedBread.realm)
        leaveManageOrg(tmpItem)
      } else if (modalFrom === 'navigate') {
        navigate("/realms");
      } else if (modalFrom === 'refresh') {
        // window.location.reload();
      } else if (modalFrom === 'cusInform') {
        handleCheck('cusInform')
      }
    }
  }

  const handlePasswordModalAction = (value) => {
    let tmpSelectedBread = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');

    if (value === 'ok') {
      let tmpItem = cloneDeep(tmpSelectedBread.realm)
      delManageOrg(tmpItem)
    }
  }

  const isNumeric = (val) => {
    if (typeof val === 'number') {
      return Number.isInteger(val) && val > 0;
    }
    if (!val || val.trim() === '') {
      return false;
    }
    if (typeof val === 'string') {
      const numberRegex = /^[0-9]+$/;
      return numberRegex.test(val) && Number(val) > 0;
    }
    return false;
  };

  const isEmpty = (val) => {
    return val == null || val.trim() === '';
  };

  return (
    <>
      <div className={mainStyle["anchorArea"]}>
        <div className={mainStyle["anchorBody"]}>
          {
            showEditGeneral && nowScope === "Organization" && <Box>
              <div
                className={mainStyle["anchorItem"]}
                style={{
                  backgroundColor: nowAnchor === "notifications" ? theme.palette.primary.main : "",
                  cursor: "pointer",
                }}
                onClick={() => handleAnchor("notifications")}
              >
                <img
                  src={nowAnchor === "notifications" ? btn_alert_light : btn_alert}
                  alt="notifications"
                  style={{ width: "40px" }}
                />
                <span
                  className={mainStyle["anchorItem_text"]}
                  style={{
                    color:
                      nowAnchor === "notifications"
                        ? theme.palette.primary.white
                        : theme.palette.primary.main,
                  }}
                >
                  Notifications
                </span>
              </div>
              <Divider
                orientation="horizontal"
                sx={{
                  borderColor: theme.palette.primary.greyThread,
                  height: "2px",
                }}
              />
            </Box>
          }
          <Box onClick={() => { handleAnchor('account') }}>
            <div className={mainStyle["anchorItem"]} style={{ backgroundColor: (nowAnchor === 'account') ? theme.palette.primary.main : '' }}>
              <img src={(nowAnchor === 'account') ? btn_general_light : btn_general} style={{ width: '40px' }} />
              <span className={mainStyle["anchorItem_text"]} style={{ color: (nowAnchor === 'account') ? theme.palette.primary.white : theme.palette.primary.main }}>General</span>
            </div>
          </Box>
          {(checkContext === 'premises') &&
            <>
              <Box onClick={() => { handleAnchor('connect') }}>
                <div className={mainStyle["anchorItem"]} style={{ backgroundColor: (nowAnchor === 'connect') ? theme.palette.primary.main : '' }}>
                  <img src={(nowAnchor === 'connect') ? btn_smtp_light : btn_smtp} style={{ width: '40px' }} />
                  <span className={mainStyle["anchorItem_text"]} style={{ color: (nowAnchor === 'connect') ? theme.palette.primary.white : theme.palette.primary.main }}>Connectivity</span>
                </div>
              </Box>
              <Box onClick={() => { handleAnchor('smtp') }}>
                <div className={mainStyle["anchorItem"]} style={{ backgroundColor: (nowAnchor === 'smtp') ? theme.palette.primary.main : '' }}>
                  <img src={(nowAnchor === 'smtp') ? btn_smtp_light : btn_smtp} style={{ width: '40px' }} />
                  <span className={mainStyle["anchorItem_text"]} style={{ color: (nowAnchor === 'smtp') ? theme.palette.primary.white : theme.palette.primary.main }}>SMTP</span>
                </div>
              </Box>
            </>
          }
        </div>
      </div>
      <div className={mainStyle["userArea"]}>
        <Grid style={{ marginBottom: '20px' }}>
          <Box id="section1" >
            {(nowAnchor === 'account') ?
              <>
                <div className={mainStyle["titleArea"]}>
                  <Typography
                    variant="h4"
                    sx={{
                      mb: 2, ml: 1, mt: 2,
                      color: theme.palette.primary.main,
                      fontFamily: theme.typography.fontFamily,
                      fontSize: theme.typography.customFontSize[5],
                      fontWeight: theme.typography.customFontWeight[3],
                    }}
                  >
                    General Settings
                  </Typography>
                </div>
                <div className={mainStyle["contentArea"]}>
                  <Grid container className={`${mainStyle['optionArea']}`}>
                    <Typography
                      sx={{
                        width: '190px',
                        color: theme.palette.primary.greyPrimary,
                        fontSize: theme.typography.customFontSize[2],
                        fontWeight: theme.typography.customFontWeight[0],
                        fontFamily: theme.typography.fontFamily,
                      }}
                    >
                      {nowScope} Name
                    </Typography>
                    {!showEditGeneral &&
                      <Typography
                        sx={{
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                        style={{ marginLeft: '10px' }}
                      >{scopeName}
                      </Typography>
                    }
                    {showEditGeneral &&
                      <TextField
                        value={scopeName}
                        size="small"
                        onChange={(e) => handleInput(e, 'scopeName')}
                        variant="outlined"
                        error={!checkScopeName}
                        inputProps={{
                          style: {
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }
                        }}
                        sx={{
                          mr: 1,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px', // 改變圓角
                            height: "29px",
                            '& fieldset': {
                              borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.mainHover,
                            },
                            "&.Mui-focused fieldset": {
                              border: '1px solid',
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                        style={{ width: '325px', paddingLeft: '10px', }}
                      />
                    }
                  </Grid>
                  {(checkContext === 'cloud') &&
                    <>
                      {showLeaveGeneral && !showInventory &&
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <LeaveIcon onClick={() => handleLeaveSetting()} style={{ cursor: 'pointer', marginRight: '5px' }} />
                          <Typography
                            onClick={() => handleLeaveSetting()}
                            style={{ cursor: 'pointer' }}
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Leave {nowScope}
                          </Typography>
                        </Grid>
                      }
                      {showDeleteGeneral && !showInventory &&
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <RemoveIcon onClick={() => handleDeleteSetting()} style={{ cursor: 'pointer', margin: '0 6px 0 2px' }} />
                          <Typography
                            onClick={() => handleDeleteSetting()}
                            style={{ cursor: 'pointer' }}
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.redPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Delete {nowScope}
                          </Typography>
                        </Grid>
                      }
                    </>
                  }
                  {/* {(checkContext === 'premises') &&
                      <>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width:'190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Captcha
                          </Typography>
                          {(enableCaptcha===true)? 
                            <SwitchOnIcon onClick={() => handleSwitchCaptcha()}
                              style={{ opacity:(showEditGeneral)?'':'0.5', cursor:(showEditGeneral)?'pointer':'not-allowed', marginLeft:'10px'}}/>
                            : 
                            <SwitchOffIcon onClick={() => handleSwitchCaptcha()}
                              style={{ opacity:(showEditGeneral)?'':'0.5', cursor:(showEditGeneral)?'pointer':'not-allowed',  marginLeft:'10px'}}/>
                          }
                        </Grid>
                      </>
                    } */}
                  {
                    nowScope === 'Organization' && <>
                      <Grid container className={`${mainStyle['optionArea']}`}>
                        <Typography
                          sx={{
                            width: '190px',
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[0],
                            fontFamily: theme.typography.fontFamily,
                          }}
                        >
                          Select Country
                        </Typography>
                        {!showEditGeneral &&
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            style={{ marginLeft: '10px' }}
                          >
                            {(selectCountry && selectCountry.label) || '-'}
                          </Typography>
                        }
                        {showEditGeneral &&
                          <Box sx={{ marginLeft: 1 }}>
                            <AutocompleteSelect
                              width="318px"
                              placeholder="Select a Country"
                              options={selectCountryList}
                              value={selectCountry}
                              setValue={setSelectCountry}
                            />
                          </Box>
                        }
                      </Grid>
                      <Grid container className={`${mainStyle['optionArea']}`}>
                        <Typography
                          sx={{
                            width: '190px',
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[0],
                            fontFamily: theme.typography.fontFamily,
                          }}
                        >
                          Time Zone
                        </Typography>
                        {!showEditGeneral &&
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            style={{ marginLeft: '10px' }}
                          >
                            {selectTimezoneData && selectTimezoneData.value}
                          </Typography>
                        }
                        {showEditGeneral &&
                          <Box sx={{ marginLeft: 1 }}>
                            <MenuSelect
                              width="318px"
                              placeholder="Select a Time Zone"
                              value={selectTimezoneData && selectTimezoneData.value}
                              onChange={(opt) => setSelectTimezoneData(opt)}
                              options={timezoneList}
                            />
                          </Box>
                        }
                      </Grid>
                      <Grid container className={`${mainStyle['optionArea']}`}>
                        <Typography
                          sx={{
                            width: '190px',
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[0],
                            fontFamily: theme.typography.fontFamily,
                          }}
                        >
                          NTP Server
                        </Typography>
                        {!showEditGeneral &&
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            style={{ marginLeft: '10px' }}
                          >
                            {ntpServers[0] || ""}
                          </Typography>
                        }
                        {showEditGeneral &&
                          <TextField
                            value={ntpServers[0] || ""}
                            size="small"
                            onChange={(e) => handleChangeNtpServer(e.target.value, 0)}
                            variant="outlined"
                            inputProps={{
                              style: {
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[2],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }
                            }}
                            sx={{
                              mr: 1,
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '8px', // 改變圓角
                                height: "29px",
                                '& fieldset': {
                                  borderColor: theme.palette.primary.greyFifth,
                                },
                                "&:hover fieldset": {
                                  borderColor: theme.palette.primary.mainHover,
                                },
                                "&.Mui-focused fieldset": {
                                  border: '1px solid',
                                  borderColor: theme.palette.primary.main,
                                },
                              },
                            }}
                            style={{ width: '325px', paddingLeft: '10px', }}
                            autoComplete="off"
                          />
                        }
                      </Grid>
                      {ntpServers.map((val, index) => {
                        if (index === 0) return null;

                        return (
                          <Grid container className={mainStyle['optionArea']} key={index}>
                            <Typography sx={{ width: "190px" }} />

                            {!showEditGeneral &&
                              <Typography
                                sx={{
                                  color: theme.palette.primary.greyPrimary,
                                  fontSize: theme.typography.customFontSize[2],
                                  fontWeight: theme.typography.customFontWeight[1],
                                  fontFamily: theme.typography.fontFamily,
                                }}
                                style={{ marginLeft: '10px' }}
                              >
                                {val}
                              </Typography>
                            }

                            {showEditGeneral && <>
                              <TextField
                                size="small"
                                value={val}
                                onChange={(e) => handleChangeNtpServer(e.target.value, index)}
                                variant="outlined"
                                inputProps={{
                                  style: {
                                    color: theme.palette.primary.greyPrimary,
                                    fontSize: theme.typography.customFontSize[2],
                                    fontWeight: theme.typography.customFontWeight[1],
                                    fontFamily: theme.typography.fontFamily,
                                  }
                                }}
                                sx={{
                                  mr: 1,
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    height: "29px",
                                    "& fieldset": {
                                      borderColor: theme.palette.primary.greyFifth,
                                    },
                                    "&:hover fieldset": {
                                      borderColor: theme.palette.primary.mainHover,
                                    },
                                    "&.Mui-focused fieldset": {
                                      border: "1px solid",
                                      borderColor: theme.palette.primary.main,
                                    },
                                  },
                                }}
                                style={{ width: "295px", paddingLeft: "10px" }}
                                autoComplete="off"
                              />

                              <StyledIconButton onClick={() => handleDeleteNtpServer(index)}>
                                <UnverifiedIcon />
                              </StyledIconButton>
                            </>
                            }
                          </Grid>
                        );
                      })}
                      {showEditGeneral &&
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography sx={{ width: '450px' }} />
                          <OutlineRectangleButton
                            onMouseEnter={() => setIsAddHovered(true)}
                            onMouseLeave={() => setIsAddHovered(false)}
                            startIcon={
                              isAddHovered ? <AddHoverIcon /> : <AddIcon />
                            }
                            width="54px"
                            height="28px"
                            onClick={handleAddNtpServer}
                            disabled={ntpServers.length >= 3}
                          >
                            Add
                          </OutlineRectangleButton>
                        </Grid>
                      }
                    </>
                  }
                </div>
                {showInventory &&
                  <div className={mainStyle["titleArea"]}>
                    <Typography
                      variant="h4"
                      sx={{
                        mb: 2, ml: 1, mt: 2,
                        color: theme.palette.primary.main,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: theme.typography.customFontSize[5],
                        fontWeight: theme.typography.customFontWeight[3],
                      }}
                    >
                      Inventory Device Account
                    </Typography>
                  </div>
                }
                <div className={mainStyle["contentArea"]}>
                  {showInventory && <>
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <Typography
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[0],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Username
                        <Typography component="span" sx={{ color: theme.palette.primary.redPrimary }}>
                          *
                        </Typography>
                      </Typography>
                      {!showEditGeneral &&
                        <Typography
                          sx={{
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[2],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }}
                          style={{ marginLeft: '10px' }}
                        >{inventoryName}
                        </Typography>
                      }
                      {showEditGeneral &&
                        <TextField
                          value={inventoryName}
                          size="small"
                          onChange={(e) => handleInput(e, 'inventoryName')}
                          variant="outlined"
                          error={userError}
                          inputProps={{
                            style: {
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }
                          }}
                          sx={{
                            mr: 1,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px', // 改變圓角
                              height: "29px",
                              '& fieldset': {
                                borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                              },
                              "&:hover fieldset": {
                                borderColor: theme.palette.primary.mainHover,
                              },
                              "&.Mui-focused fieldset": {
                                border: '1px solid',
                                borderColor: theme.palette.primary.main,
                              },
                            },
                          }}
                          style={{ width: '325px', paddingLeft: '10px', }}
                        />
                      }
                    </Grid>
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <Typography
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[2],
                          fontWeight: theme.typography.customFontWeight[0],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Password
                        <Typography component="span" sx={{ color: theme.palette.primary.redPrimary }}>
                          *
                        </Typography>
                      </Typography>
                      {!showEditGeneral &&
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            style={{ marginLeft: '10px' }}
                          > {showDevicePw ? inventoryPW : '•'.repeat(inventoryPW?.length || 8)}
                          </Typography>
                          <Box sx={{ marginLeft: "8px" }}>
                            <StyledIconButton onClick={handleShowDevicePw}>
                              {!showDevicePw ? <HideIcon /> : <ShowIcon />}
                            </StyledIconButton>
                          </Box>
                        </Box>
                      }
                      {showEditGeneral &&
                        <TextField
                          value={inventoryPW}
                          size="small"
                          onChange={(e) => handleInput(e, 'inventoryPW')}
                          variant="outlined"
                          error={userPWError}
                          inputProps={{
                            style: {
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }
                          }}
                          type={showDevicePw ? 'text' : 'password'}
                          sx={{
                            mr: 1,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px', // 改變圓角
                              height: "29px",
                              '& fieldset': {
                                borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                              },
                              "&:hover fieldset": {
                                borderColor: theme.palette.primary.mainHover,
                              },
                              "&.Mui-focused fieldset": {
                                border: '1px solid',
                                borderColor: theme.palette.primary.main,
                              },
                            },
                          }}
                          style={{ width: '325px', paddingLeft: '10px', }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {!showDevicePw && <HideIcon onClick={handleShowDevicePw} style={{ cursor: 'pointer' }} />}
                                {showDevicePw && <ShowIcon onClick={handleShowDevicePw} style={{ cursor: 'pointer' }} />}
                              </InputAdornment>
                            ),
                          }}
                        />
                      }
                    </Grid>
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <Typography
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[1],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      />
                      {userPWError &&
                        <Typography
                          sx={{
                            fontSize: theme.typography.customFontSize[3],
                            color: theme.palette.primary.redPrimary,
                          }}
                          style={{ marginLeft: '10px' }}
                        >{userPWError}
                        </Typography>
                      }
                    </Grid>
                  </>
                  }
                  {(checkContext === 'cloud') &&
                    <>
                      {showLeaveGeneral && showInventory &&
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <LeaveIcon onClick={() => handleLeaveSetting()} style={{ cursor: 'pointer', marginRight: '5px' }} />
                          <Typography
                            onClick={() => handleLeaveSetting()}
                            style={{ cursor: 'pointer' }}
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Leave {nowScope}
                          </Typography>
                        </Grid>
                      }
                      {showDeleteGeneral && showInventory &&
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <RemoveIcon onClick={() => handleDeleteSetting()} style={{ cursor: 'pointer', margin: '0 6px 0 2px' }} />
                          <Typography
                            onClick={() => handleDeleteSetting()}
                            style={{ cursor: 'pointer' }}
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.redPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Delete {nowScope}
                          </Typography>
                        </Grid>
                      }
                    </>
                  }
                </div>
                {showEditGeneral && <Box>
                  <Grid container style={{ justifyContent: 'center', width: '100%' }}>
                    <Box style={{ margin: '10px' }}>
                      <OutlineButton width="135px" height="42px" onClick={() => handleCancelGeneral()}
                        disabled={showEditGeneral ? false : true}>
                        Cancel
                      </OutlineButton>
                    </Box>
                    <Box style={{ margin: '10px' }}>
                      <SolidButton width="135px" height="42px" onClick={() => handleSaveGeneral()}
                        disabled={!inventoryName || userError || !inventoryPW || userPWError}>
                        Save
                      </SolidButton>
                    </Box>
                  </Grid>
                </Box>}
              </>
              :
              (nowAnchor === 'connect') ?
                <>
                  <div className={mainStyle["titleArea"]}>
                    <Typography
                      variant="h4"
                      sx={{
                        mb: 2, ml: 1, mt: 2,
                        color: theme.palette.primary.main,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: theme.typography.customFontSize[5],
                        fontWeight: theme.typography.customFontWeight[3],
                      }}
                    >
                      Connectivity Settings
                    </Typography>
                  </div>
                  <div className={mainStyle["contentArea"]}>
                    <Grid container className={`${mainStyle['optionArea']}`}>
                      <Typography
                        sx={{
                          width: '190px',
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[1],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Inform Host
                      </Typography>
                      {(enableCusInform === true) ?
                        <CheckOnIcon width={20} onClick={() => handleEnableCusInform()}
                          style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginLeft: '10px' }} />
                        :
                        <CheckOffIcon width={20} onClick={() => handleEnableCusInform()}
                          style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginLeft: '10px' }} />
                      }
                      <Typography
                        sx={{
                          ml: 1, mr: 1,
                          color: theme.palette.primary.greyPrimary,
                          fontSize: theme.typography.customFontSize[1],
                          fontWeight: theme.typography.customFontWeight[1],
                          fontFamily: theme.typography.fontFamily,
                        }}
                      >
                        Custom
                      </Typography>
                      {(showEditGeneral === true) ?
                        <TextField
                          value={informHost}
                          placeholder="host.yourdomain.com or 203.0.113.42"
                          size="small"
                          onChange={(e) => handleInput(e, 'informHost')}
                          variant="outlined"
                          error={!checkInformHost}
                          inputProps={{ style: { fontSize: '13px' } }}
                          sx={{
                            mr: 1,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px', // 改變圓角
                              height: "29px",
                              '& fieldset': {
                                borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                              },
                              "&:hover fieldset": {
                                borderColor: theme.palette.primary.mainHover,
                              },
                              "&.Mui-focused fieldset": {
                                border: '1px solid',
                                borderColor: theme.palette.primary.main,
                              },
                            },
                          }}
                          style={{ width: '325px', paddingLeft: '10px', }}
                        />
                        :
                        <Typography
                          sx={{
                            ml: 1, mr: 1,
                            color: theme.palette.primary.greyPrimary,
                            fontSize: theme.typography.customFontSize[1],
                            fontWeight: theme.typography.customFontWeight[1],
                            fontFamily: theme.typography.fontFamily,
                          }}
                        >
                          {informHost}
                        </Typography>
                      }
                    </Grid>
                  </div>
                  {showEditGeneral && <Box>
                    <Grid container style={{ justifyContent: 'center', width: '100%' }}>
                      <Box style={{ margin: '10px' }}>
                        <OutlineButton width="135px" height="42px" onClick={() => handleCancelInformHost()}
                          disabled={showEditGeneral ? false : true}>
                          Cancel
                        </OutlineButton>
                      </Box>
                      <Box style={{ margin: '10px' }}>
                        <SolidButton width="135px" height="42px" onClick={() => handleSaveInformHost()}
                          disabled={showEditGeneral ? false : true}>
                          Save
                        </SolidButton>
                      </Box>
                    </Grid>
                  </Box>}
                </>
                :
                (nowScope === "Organization" && nowAnchor === "notifications") ?
                  <Notifications showEditGeneral={showEditGeneral} />
                  :
                  <>
                    <div className={mainStyle["titleArea"]}>
                      <Typography
                        variant="h4"
                        sx={{
                          mb: 2, ml: 1, mt: 2,
                          color: theme.palette.primary.main,
                          fontFamily: theme.typography.fontFamily,
                          fontSize: theme.typography.customFontSize[5],
                          fontWeight: theme.typography.customFontWeight[3],
                        }}
                      >
                        SMTP Server Settings
                      </Typography>
                      {(enableSMTP === true) ?
                        <SwitchOnIcon onClick={() => handleSwitchSMTP()}
                          style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginLeft: '10px' }} />
                        :
                        <SwitchOffIcon onClick={() => handleSwitchSMTP()}
                          style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginLeft: '10px' }} />
                      }
                    </div>
                    {!enableSMTP && <>
                      <Box style={{ height: '30px' }}></Box>
                    </>}
                    {enableSMTP && <>
                      <div className={mainStyle["contentArea"]}>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            SMTP Server (Host)
                          </Typography>
                          {!showEditGeneral &&
                            <Typography
                              sx={{
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                              style={{ marginLeft: '10px' }}
                            >{host}
                            </Typography>
                          }
                          {showEditGeneral &&
                            <TextField
                              value={host}
                              size="small"
                              onChange={(e) => handleInput(e, 'host')}
                              variant="outlined"
                              error={!checkHost}
                              inputProps={{ style: { fontSize: '13px' } }}
                              sx={{
                                mr: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px', // 改變圓角
                                  height: "29px",
                                  '& fieldset': {
                                    borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor: theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{ width: '325px', paddingLeft: '10px', }}
                            />
                          }
                        </Grid>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Port
                          </Typography>
                          {!showEditGeneral &&
                            <Typography
                              sx={{
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                              style={{ marginLeft: '10px' }}
                            >{port}
                            </Typography>
                          }
                          {showEditGeneral &&
                            <TextField
                              value={port}
                              size="small"
                              onChange={(e) => handleInput(e, 'port')}
                              variant="outlined"
                              error={!checkPort}
                              inputProps={{ style: { fontSize: '13px' } }}
                              sx={{
                                mr: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px', // 改變圓角
                                  height: "29px",
                                  '& fieldset': {
                                    borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor: theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{ width: '325px', paddingLeft: '10px', }}
                            />
                          }
                        </Grid>

                        <Grid container className={`${mainStyle['optionArea']}`}>
                          {(enableAuth === true) ?
                            <CheckOnIcon width={20} onClick={() => handleCheck('auth')}
                              style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginRight: '10px' }} />
                            :
                            <CheckOffIcon width={20} onClick={() => handleCheck('auth')}
                              style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginRight: '10px' }} />
                          }
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Authentication Required
                          </Typography>
                        </Grid>
                        {(enableAuth === true) && <>
                          <Grid container className={`${mainStyle['optionArea']}`}>
                            <Typography
                              sx={{
                                width: '160px', ml: '30px',
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                            >
                              User name
                            </Typography>
                            {!showEditGeneral &&
                              <Typography
                                sx={{
                                  color: theme.palette.primary.greyPrimary,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight: theme.typography.customFontWeight[1],
                                  fontFamily: theme.typography.fontFamily,
                                }}
                                style={{ marginLeft: '10px' }}
                              >{authName}
                              </Typography>
                            }
                            {showEditGeneral &&
                              <TextField
                                value={authName}
                                size="small"
                                onChange={(e) => handleInput(e, 'authName')}
                                variant="outlined"
                                error={!checkAuthName}
                                inputProps={{ style: { fontSize: '13px' } }}
                                sx={{
                                  mr: 1,
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px', // 改變圓角
                                    height: "29px",
                                    '& fieldset': {
                                      borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                    },
                                    "&:hover fieldset": {
                                      borderColor: theme.palette.primary.mainHover,
                                    },
                                    "&.Mui-focused fieldset": {
                                      border: '1px solid',
                                      borderColor: theme.palette.primary.main,
                                    },
                                  },
                                }}
                                style={{ width: '325px', paddingLeft: '10px', }}
                              />
                            }
                          </Grid>
                          <Grid container className={`${mainStyle['optionArea']}`}>
                            <Typography
                              sx={{
                                width: '160px', ml: '30px',
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                            >
                              Password
                            </Typography>
                            {!showEditGeneral &&
                              <Typography
                                sx={{
                                  color: theme.palette.primary.greyPrimary,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight: theme.typography.customFontWeight[1],
                                  fontFamily: theme.typography.fontFamily,
                                }}
                                style={{ marginLeft: '10px' }}
                              >{authPW}
                              </Typography>
                            }
                            {showEditGeneral &&
                              <TextField
                                value={authPW}
                                size="small"
                                onChange={(e) => handleInput(e, 'authPW')}
                                variant="outlined"
                                error={!checkAuthPW}
                                inputProps={{ style: { fontSize: '13px' } }}
                                sx={{
                                  mr: 1,
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px', // 改變圓角
                                    height: "29px",
                                    '& fieldset': {
                                      borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                    },
                                    "&:hover fieldset": {
                                      borderColor: theme.palette.primary.mainHover,
                                    },
                                    "&.Mui-focused fieldset": {
                                      border: '1px solid',
                                      borderColor: theme.palette.primary.main,
                                    },
                                  },
                                }}
                                style={{ width: '325px', paddingLeft: '10px', }}
                              />
                            }
                          </Grid>
                        </>}
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          {(enableSslTls === true) ?
                            <CheckOnIcon width={20} onClick={() => handleCheck('ssltls')}
                              style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginRight: '10px' }} />
                            :
                            <CheckOffIcon width={20} onClick={() => handleCheck('ssltls')}
                              style={{ opacity: (showEditGeneral) ? '' : '0.5', cursor: (showEditGeneral) ? 'pointer' : 'not-allowed', marginRight: '10px' }} />
                          }
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Require SSL / TLS
                          </Typography>
                        </Grid>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          {showEditGeneral &&
                            <SolidRectangleLightButton width="160px" height="35px"
                              sx={{ ml: '200px', mt: '10px' }}
                              startIcon={<ConnectIcon />}
                              onClick={() => handleTestConnect()}
                              disabled={showEditGeneral ? false : true}>
                              {testConnectBtnText}
                            </SolidRectangleLightButton>
                          }
                          {showConnectInfo && <>
                            <Box sx={{ mt: '25px', ml: '20px' }}>
                              {(testConnectResult.type === 'ok') ? <InfoSuccessIcon width={20} /> : <InfoAlertIcon width={20} />}
                            </Box>
                            <Box sx={{ mt: '20px' }}>
                              <Typography
                                sx={{
                                  color: (testConnectResult.type === 'ok') ? theme.palette.primary.greenSecound : theme.palette.primary.redPrimary,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight: theme.typography.customFontWeight[1],
                                  fontFamily: theme.typography.fontFamily,
                                }}
                                style={{ marginLeft: '10px' }}
                              >{testConnectResult.message}
                              </Typography>
                            </Box>
                          </>}
                        </Grid>
                      </div>

                      <div className={mainStyle["titleArea"]}>
                        <Typography
                          variant="h4"
                          sx={{
                            mb: 2, ml: 1, mt: 2,
                            color: theme.palette.primary.main,
                            fontFamily: theme.typography.fontFamily,
                            fontSize: theme.typography.customFontSize[5],
                            fontWeight: theme.typography.customFontWeight[3],
                          }}
                        >
                          Sender
                        </Typography>
                        <Divider
                          orientation="vertical" variant="middle" flexItem
                          sx={{
                            borderColor: theme.palette.primary.greyThread,
                            borderWidth: 1, marginRight: "15px", marginLeft: '15px',
                          }}
                        />
                        <Typography
                          variant="h4"
                          sx={{
                            color: theme.palette.primary.main,
                            fontFamily: theme.typography.fontFamily,
                            fontSize: theme.typography.customFontSize[1],
                            fontWeight: theme.typography.customFontWeight[0],
                          }}
                        >
                          System notifications will be sent ffrom the sender's email address
                        </Typography>
                      </div>
                      <div className={mainStyle["contentArea"]}>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Email
                          </Typography>
                          {!showEditGeneral &&
                            <Typography
                              sx={{
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                              style={{ marginLeft: '10px' }}
                            >{mail}
                            </Typography>
                          }
                          {showEditGeneral &&
                            <TextField
                              value={mail}
                              size="small"
                              onChange={(e) => handleInput(e, 'mail')}
                              variant="outlined"
                              error={!checkMail}
                              inputProps={{ style: { fontSize: '13px' } }}
                              sx={{
                                mr: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px', // 改變圓角
                                  height: "29px",
                                  '& fieldset': {
                                    borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor: theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{ width: '325px', paddingLeft: '10px', }}
                            />
                          }
                        </Grid>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Name
                          </Typography>
                          {!showEditGeneral &&
                            <Typography
                              sx={{
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                              style={{ marginLeft: '10px' }}
                            >{senderName}
                            </Typography>
                          }
                          {showEditGeneral &&
                            <TextField
                              value={senderName}
                              size="small"
                              onChange={(e) => handleInput(e, 'senderName')}
                              variant="outlined"
                              error={!checkSenderName}
                              inputProps={{ style: { fontSize: '13px' } }}
                              sx={{
                                mr: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px', // 改變圓角
                                  height: "29px",
                                  '& fieldset': {
                                    borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor: theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{ width: '325px', paddingLeft: '10px', }}
                            />
                          }
                        </Grid>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          <Typography
                            sx={{
                              width: '190px',
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Receiver Email Address
                          </Typography>
                          {!showEditGeneral &&
                            <Typography
                              sx={{
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight: theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                              style={{ marginLeft: '10px' }}
                            >{receiverMail}
                            </Typography>
                          }
                          {showEditGeneral &&
                            <TextField
                              value={receiverMail}
                              size="small"
                              onChange={(e) => handleInput(e, 'receiverMail')}
                              variant="outlined"
                              error={!checkReceivertMail}
                              inputProps={{ style: { fontSize: '13px' } }}
                              sx={{
                                mr: 1,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px', // 改變圓角
                                  height: "29px",
                                  '& fieldset': {
                                    borderColor: theme.palette.primary.greyFifth, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor: theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{ width: '325px', paddingLeft: '10px', }}
                            />
                          }
                        </Grid>
                        <Grid container className={`${mainStyle['optionArea']}`}>
                          {showEditGeneral &&
                            <SolidRectangleLightButton width="160px" height="35px"
                              sx={{ ml: '200px', mt: '10px' }}
                              startIcon={<SendMailIcon />}
                              onClick={() => handleSendMail()}
                              disabled={showEditGeneral ? false : true}>
                              {sendMailBtnText}
                            </SolidRectangleLightButton>
                          }
                          {showSendInfo && <>
                            <Box sx={{ mt: '25px', ml: '20px' }}>
                              {(sendMailResult.type === 'ok') ? <InfoSuccessIcon width={20} /> : <InfoAlertIcon width={20} />}
                            </Box>
                            <Box sx={{ mt: '20px' }}>
                              <Typography
                                sx={{
                                  color: (sendMailResult.type === 'ok') ? theme.palette.primary.greenSecound : theme.palette.primary.redPrimary,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight: theme.typography.customFontWeight[1],
                                  fontFamily: theme.typography.fontFamily,
                                }}
                                style={{ marginLeft: '10px' }}
                              >{sendMailResult.message}
                              </Typography>
                            </Box>
                          </>}
                        </Grid>
                      </div>
                    </>}
                    {showEditGeneral && <Box>
                      <Grid container style={{ justifyContent: 'center', width: '100%' }}>
                        <Box style={{ margin: '10px' }}>
                          <OutlineButton width="135px" height="42px" onClick={() => handleCancelSMTP()}
                            disabled={showEditGeneral ? false : true}>
                            Cancel
                          </OutlineButton>
                        </Box>
                        <Box style={{ margin: '10px' }}>
                          <SolidButton width="135px" height="42px" onClick={() => handleSaveSMTP()}
                            disabled={showEditGeneral ? false : true}>
                            Save
                          </SolidButton>
                        </Box>
                      </Grid>
                    </Box>}
                  </>
            }
          </Box>
        </Grid>
      </div>

      <ModalContainer
        display={openModalCheck}
        modalWidth={'550px'} //550px, 750px, empty=1000px,
        children={
          <ModalforCheck
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalCheck}
            onBottonClick={handleCheckModalAction}
          />
        }
      />
      <ModalContainer
        display={openModalConfirmPw}
        modalWidth={'500px'} //550px, 750px, empty=1000px,
        children={
          <ModalConfirmPw
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalConfirmPw}
            originUser={originUser}
            onBottonClick={handlePasswordModalAction}
          />
        }
      />
    </>
  );
};

export default MspLevel;